import { useMemo } from 'react';
import { parseLegalDoc } from '@/lib/parseLegalDoc';
import termsRaw from '@/lib/terms.txt?raw';

function SectionBody({ body, isAllCaps }: { body: string; isAllCaps?: boolean }) {
  const blocks = useMemo(() => body.split(/\n\n+/).filter(Boolean), [body]);
  return (
    <div className={isAllCaps ? 'uppercase text-mirror-muted' : ''}>
      {blocks.map((block, i) => (
        <p key={i} className="mb-3 text-sm leading-relaxed text-mirror-muted last:mb-0">
          {block.split('\n').map((line, j) => (
            <span key={j}>
              {j > 0 && <br />}
              {line.trim()}
            </span>
          ))}
        </p>
      ))}
    </div>
  );
}

export default function Terms() {
  const { title, effectiveDate, intro, sections } = useMemo(() => parseLegalDoc(termsRaw), []);

  return (
    <div className="mx-auto max-w-3xl">
      <h1 className="font-display mb-2 text-2xl font-semibold tracking-wide text-mirror-text">
        {title}
      </h1>
      <p className="mb-8 text-sm text-mirror-muted">
        {effectiveDate}
      </p>

      {intro.map((para, i) => (
        <p key={i} className="mb-4 text-sm leading-relaxed text-mirror-muted">
          {para}
        </p>
      ))}

      <div className="mt-10 space-y-10">
        {sections.map((sec) => {
          const isAllCaps = sec.number === '18' || sec.number === '19';
          return (
            <section key={sec.number} id={`section-${sec.number}`}>
              <h2 className="mb-3 text-lg font-medium text-mirror-gold">
                {sec.number}. {sec.title}
              </h2>
              <SectionBody body={sec.body} isAllCaps={isAllCaps} />
            </section>
          );
        })}
      </div>
    </div>
  );
}
